/** One-time integration handoff payloads from Concierge journey steps. */

const PAYLOAD_PREFIX = "sami:integration-handoff-payload";
const CONSUMED_PREFIX = "sami:integration-handoff-consumed";

export interface IntegrationHandoffPayload {
  initialPrompt: string;
  productUuid?: string;
  tab?: string;
}

export function storeIntegrationHandoffPayload(
  handoffId: string,
  payload: IntegrationHandoffPayload,
): void {
  sessionStorage.setItem(
    `${PAYLOAD_PREFIX}:${handoffId}`,
    JSON.stringify(payload),
  );
}

export function loadIntegrationHandoffPayload(
  handoffId: string,
): IntegrationHandoffPayload | null {
  try {
    const raw = sessionStorage.getItem(`${PAYLOAD_PREFIX}:${handoffId}`);
    if (!raw) return null;
    return JSON.parse(raw) as IntegrationHandoffPayload;
  } catch {
    return null;
  }
}

export function markIntegrationHandoffConsumed(handoffId: string): void {
  sessionStorage.setItem(`${CONSUMED_PREFIX}:${handoffId}`, "1");
}

export function isIntegrationHandoffConsumed(handoffId: string): boolean {
  return sessionStorage.getItem(`${CONSUMED_PREFIX}:${handoffId}`) === "1";
}

export function createHandoffId(): string {
  return crypto.randomUUID();
}
